<template>
  <div>
    <b-form-group
      :id="'item-' + itemId"
      :label="consulta"
      label-for="rating"
      :label-cols="labelCols"
      horizontal>
      <div class="rating">
        <div class="star">
          <i @click="setCalificacion(1)"
            :class="{  
                    'fa': true,
                    'fa-star': calificacion >= 1 ? true : false,
                    'fa-star-o': calificacion < 1 ? true : false,
                    'disabled': readOnly ? true : false
                    }"></i>
        </div>
        <div class="star">
          <i @click="setCalificacion(2)"
            :class="{  
                    'fa': true,
                    'fa-star': calificacion >= 2 ? true : false,
                    'fa-star-o': calificacion < 2 ? true : false, 
                    'disabled': readOnly ? true : false
                    }"></i>
        </div>
        <div class="star">
          <i @click="setCalificacion(3)"
            :class="{  
                    'fa': true,
                    'fa-star': calificacion >= 3 ? true : false,
                    'fa-star-o': calificacion < 3 ? true : false, 
                    'disabled': readOnly ? true : false
                    }"></i>
        </div>
        <div class="star">
          <i @click="setCalificacion(4)" 
            :class="{  
                    'fa': true,
                    'fa-star': calificacion >= 4 ? true : false,
                    'fa-star-o': calificacion < 4 ? true : false, 
                    'disabled': readOnly ? true : false
                    }"></i>
        </div>
        <div class="star">
          <i @click="setCalificacion(5)"
            :class="{  
                    'fa': true,
                    'fa-star': calificacion >= 5 ? true : false,
                    'fa-star-o': calificacion < 5 ? true : false, 
                    'disabled': readOnly ? true : false
                    }"></i>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'EncuestaUsuarioCalificacion',
  props: {
    itemId: {
      type: Number,
      default: 0
    },
    consulta: {
      type: String,
      default: ''
    },
    calificacion: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelCols: 8,
    }
  },
  created() {
  },  
  methods: {
    setCalificacion(calificacion) {
      // console.log('emit', calificacion);
      this.$emit('setCalificacion', calificacion);
    }
  }
}
</script>

<style >
  .rating .star i {
    top: 5px;
  }
</style>
